import React from "react";
import Heading from "../Reuse/Heading";
import IncomeCard from "../Reuse/IncomeCard";
import { BsCurrencyDollar } from "react-icons/bs";
import { FaChalkboardTeacher } from "react-icons/fa";

function StarShowcaseIncome({ props }) {
  return (
    <>
      <div className="row">
        <Heading
          title={"Star Showcase"}
          icon={<FaChalkboardTeacher size={50} />}
        />
        <IncomeCard
          title={"Total"}
          amount={props?.totalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Daily"}
          amount={props?.dailyTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Weekly"}
          amount={props?.weeklyTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Monthly"}
          amount={props?.monthlyTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
        <IncomeCard
          title={"Yearly"}
          amount={props?.yearlyTotalIncome}
          id={1}
          icon={<BsCurrencyDollar size={50} />}
        />
      </div>
    </>
  );
}

export default StarShowcaseIncome;
